import * as React from 'react'
import { createStyles, LinearProgress, Theme, WithStyles, withStyles } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import Page from 'src/shared/Page/Page'
import { WithToast } from 'src/type/lib/withToast'
import { RouteComponentProps, withRouter } from 'react-router'
import { withToast } from 'src/shared/Toast'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import PageHead from 'src/shared/PageHead/PageHead'
import FormToAnswer from 'src/shared/FormArkea/FormToAnswer'
import { formAction } from 'src/core/redux/action/formAction'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import FormToAnswerV2 from 'src/shared/FormArkea/FormToAnswerV2'

const styles = (t: Theme) => createStyles({
  root: {
    padding: t.spacing.unit * 3,
  }
})

interface IProps extends WithI18n,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

interface IState {
  formVersion: number,
  loading: boolean,
}

class Form extends React.Component<IProps, IState> {

  state: IState = {
    formVersion: 1,
    loading: true,
  }

  render() {
    const { form } = this.props

    if (this.state.loading) return (<LinearProgress />)
    
    return (
      <>
        {form &&
          <>
            <HelmetMeta title={form.name} />
            <PageHead title={form.name} />
            <Page withHead>
              {!this.state.loading &&
                <>
                  {this.state.formVersion === 1 ?
                    <FormToAnswer />
                    :
                    <FormToAnswerV2 />
                  }
                </>
              }
            </Page>
          </>
        }
      </>
    )
  }


  componentDidMount() {
    const { enterprise, fetchForm, getFormVersion } = this.props
    this.setState({ loading: true })
    getFormVersion(enterprise.id).then(res => {
      fetchForm(enterprise.id, res.version)
      this.setState({ formVersion: res.version, loading: false })
    })
  }
}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected,
  form: state.formAnswer.form,
})

const dispatch2props = (dispatch: any, ownProps: any) => ({
  fetchForm: (id: string, version: number) => dispatch(formAction.fetchForm(id, version)),
  getFormVersion: (id: string) => dispatch(formAction.getQPversion(id))
})

export default compose(
  withI18n,
  withStyles(styles),
  withRouter,
  withToast,
  connect(state2props, dispatch2props),
)(Form)



// WEBPACK FOOTER //
// ./src/page/Consumer/Form/Form.tsx